
<script>
import BarList from '../components/bar-list'
import EstadoForm from './estado-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
            uf: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
        }
    },

    computed: {
        estadoList: function () {
            return this.$store.getters.getEstadoList
        }
    },

    methods: {
        handleEdit (uf) {
            //abre a tela de edicao
            this.crud = SysVars.crudU;
            this.uf = uf
            this.showForm = true;
        },
        
        handleNew () {
            //inclusao de registro
            this.crud = SysVars.crudI
            this.uf = ''
            this.showForm = true;
        },

        closeForm() {
            this.showForm = false
        },

        search(value) {
            //efetua a pesquisa
            this.filter = '{"$or":[{"uf":{"$like":"%25' + value + '%25"}},{"nomeuf":{"$like":"%25' + value + '%25"}}]}'
            this.loadData()
        },

        loadData() {
            this.$store.dispatch('loadEstado', { filter: this.filter } )
        }

    },

    components: {
        BarList, EstadoForm
    },

    created () {
        this.showForm = false
        this.loadData()
    }

}

</script>

<template>
    <div>
        <div id="list" v-show="!showForm"> 
            <bar-list
                :refresh-button="true" 
                :new-button="true" 
                :pdf-button="false" 
                :xls-button="false"
                single-entity="Estado" 
                plural-entity="Estados"
                @search="search"
                @new="handleNew"
                @refresh="loadData"
                title-search="Pesquise pela UF ou pelo nome">
            </bar-list>
            <br>
            <div class="default-container nb-card-list">
                <alert v-if="estadoList.length == 0" type="norecord"></alert>

                <article class="nb-card" v-for="estado in estadoList" :key="estado.uf">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-unit">
                                {{ estado.uf }}
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ estado.nomeuf }}</h2>
                                </div>
                                <div class="nb-card-code">
                                    UF <strong>{{ estado.uf }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid 
                                :options="{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'}" 
                                :moreActions="[]" 
                                v-on:edit="handleEdit(estado.uf)" 
                                v-on:view="handleEdit(estado.uf, true)">
                            </bar-grid>
                        </div>
                    </div>

                    <div class="nb-card-details">
                        <div class="nb-card-detail" v-if="metadata && metadata.estado && metadata.estado.aicminterno">
                            <span class="nb-card-detail-label">{{ metadata.estado.aicminterno.label }}</span>
                            <strong>{{ estado.aicminterno | formatValue }}%</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.estado && metadata.estado.aicminter">
                            <span class="nb-card-detail-label">{{ metadata.estado.aicminter.label }}</span>
                            <strong>{{ estado.aicminter | formatValue }}%</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.estado && metadata.estado.ricm">
                            <span class="nb-card-detail-label">{{ metadata.estado.ricm.label }}</span>
                            <strong>{{ estado.ricm | formatValue }}%</strong>
                        </div>
                        <div class="nb-card-detail" v-if="metadata && metadata.estado && metadata.estado.mva">
                            <span class="nb-card-detail-label">{{ metadata.estado.mva.label }}</span>
                            <strong>{{ estado.mva | formatValue }}%</strong>
                        </div>
                    </div>
                </article>
            </div>
        </div>
        <estado-form v-if="showForm" :index="this.uf" :crud="this.crud" v-on:closeform="closeForm"></estado-form>
    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-unit {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-actions {
  flex: 0 0 auto;
}

.nb-card-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  margin: 12px 0 0 60px;
  padding-top: 11px;
  border-top: 1px solid #f1f5f9;
}

.nb-card-detail {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 3px;
}

.nb-card-detail-label {
  color: #64748b;
  font-size: 11px;
}

.nb-card-detail > strong {
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }

  .nb-card-details {
    margin-left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/estado-list.vue